import React, { useEffect, useState } from "react";
import Pagelayout from "../../../components/Pagelayout";
import CustomTable from "../../../components/ListPageComponent";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { clearRdxStateFunc } from "../../../utilFunc";
import { variableAndRecurringAPI } from "../../../parollAPIs";
import { VIEW_TYPE } from "../../../payrollEnums";
import { splitDate } from "../../../../../../util/utilityFunctions";
import { setPaginationData } from "../../../payrollSlice";

const RecurringAllowance = () => {
  const dispatch = useDispatch();
   const { listData, paginationData, searchInput } = useSelector(
     (state) => state.payrollSlice
   );
 
   const headers = [
     { key: "date", label: "Date" },
     { key: "employee", label: "Employee" },
     { key: "allowance", label: "Allowance" },
     { key: "amount", label: "Amount" },
   ];
   const [data, setData] = useState([]);
   const [loading, setLoading] = useState(false);
 
   const visibleColumns = ["date", "employee", "allowance", "amount"];
 
   //handle row click
   const handleRowClick = (rowData) => {
     console.log("Clicked row data:", rowData);
     navigate(`create`, {
       state: { _id: rowData?._id },
     });
   };
 
   const navigate = useNavigate();
 
   const handleCreateBtn = (data) => {
     // console.log("Create Pay Head", data);
     navigate("create");
   };
 
   // Clear single view data on component mount
   useEffect(() => {
     clearRdxStateFunc();
   }, [dispatch]);
 
   //refetch
   useEffect(() => {
     variableAndRecurringAPI({
       body: {
         isAllowance: true,
         search: searchInput || "",
         isRecurring: true,
         page: paginationData.currentPage,
         limit: 15,
       },
       viewType: VIEW_TYPE.LIST,
       setLoading,
     });
   }, [searchInput,paginationData.currentPage]);
 
   //initial api
   useEffect(() => {
     if (listData) {
       const formattedListData = listData?.list?.map((res) => {
         return {
           date: splitDate(res?.date) || "--",
           employee: res?.empName || "--",
           allowance: res?.allowanceName || 0,
           amount: res?.amount || 0,
           _id: res?._id || null,
         };
       });
       dispatch(
         setPaginationData({
           currentPage: paginationData?.currentPage || 1,
           totalPages: listData?.totalPages || 0,
         })
       );
       setData(formattedListData);
     } else {
      setData([])
       variableAndRecurringAPI({
         body: {
           isAllowance: true,
           search: "",
           isRecurring: true,
           page: paginationData.currentPage,
           limit: 15,
         },
         viewType: VIEW_TYPE.LIST,
         setLoading,
       });
     }
   }, [listData]);
  return (
    <Pagelayout
    pageName="RECURRING - ALLOWANCE"
    headerLayout={1}
    handleCreateBtn={handleCreateBtn}
    // filterOptions={filterOptions}
    filter={false}
    pagination={paginationData.totalPages > 1 ? true : false}
  >
    <CustomTable
      headers={headers}
      data={data}
      visibleColumns={visibleColumns}
      onRowClick={handleRowClick}
      loading={loading}
    />
  </Pagelayout>
  );
};

export default RecurringAllowance;
